<!--
 * @Description: 项目列表
-->

<template>
  <page-header-wrapper>
    <ContentLayout class="project_list_wrapper page_content">
      <FilterForm ref="FilterForm" @search="updateTable" slot="top"></FilterForm>
      <MainTable ref="MainTable" class="main_table mt-10" :getFilter="getFilter"></MainTable>
    </ContentLayout>
  </page-header-wrapper>
</template>

<script>
import FilterForm from './components/FilterForm.vue'
import MainTable from './components/MainTable.vue'

export default {
  name: 'ProjectList',
  components: {
    FilterForm,
    MainTable
  },
  data() {
    return {}
  },
  methods: {
    getFilter() {
      return this.$refs.FilterForm.form
    },
    updateTable() {
      this.$refs.MainTable.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.btn_area {
  text-align: right;
}

.main_table {
  flex: 1;
}
</style>
